<template>
    <el-tabs type="border-card" style='height:400px;'>
        <el-tab-pane>
            <span slot="label" class='tx-13'><i class="el-icon-folder-opened"></i> Investment Strategy</span>
            <DocumentsTab :params="params.investment"
            :tableData="tableData.investment" 
            :loading="loading.investment"
            :grid="grid.investment"
            :multipleSelection="multipleSelection.investment"
            :subfolder='subfolder.investment' />
        </el-tab-pane>
        <el-tab-pane>
            <span slot="label" class='tx-13'><i class="el-icon-folder-opened"></i> Permanent File</span>
            <DocumentsTab :params="params.permanent"
            :tableData="tableData.permanent" 
            :loading="loading.permanent"
            :grid="grid.permanent"
            :multipleSelection="multipleSelection.permanent"
            :subfolder='subfolder.permanent' />
        </el-tab-pane>
        <el-tab-pane>
            <span slot="label" class='tx-13'><i class="el-icon-folder-opened"></i> Signed Financials and Tax Returns 
                <i v-show="subfolder.financials" class="el-icon-arrow-right">{{params.financials}}</i>
            </span>
            <DocumentsTab :params="params.financials"
            :tableData="tableData.financials" 
            :loading="loading.financials"
            :grid="grid.financials"
            :multipleSelection="multipleSelection.financials"
            :subfolder='subfolder.financials' />     
        </el-tab-pane>
        <el-tab-pane>
            <span slot="label" class='tx-13'><i class="el-icon-folder-opened"></i> Trust Deeds</span>
            <DocumentsTab :params="params.deeds"
            :tableData="tableData.deeds" 
            :loading="loading.deeds"
            :grid="grid.deeds"
            :multipleSelection="multipleSelection.deeds"
            :subfolder='subfolder.deeds' />
        </el-tab-pane>
    </el-tabs>
</template>
<script>
export default {
    name: 'documents',
    components: {
        DocumentsTab : ()=>import('./documents_tabs/DocumentsTab.vue'),

    },
    data(){
        return {
            params:{
                financials:'financials',
                permanent:'permanent',
                investment:'investment',
                deeds:'deeds'
            },
            tableData:{
                financials:[],
                permanent:[],
                investment:[],
                deeds:[]
            },
            loading:{
                financials:true,
                permanent:true,
                investment:true,
                deeds:true
            },
            grid:{
                financials:false,
                permanent:false,
                investment:false,
                deeds:false
            },
            multipleSelection: {
                financials:[],
                permanent:[],
                investment:[],
                deeds:[]
            },
            subfolder:{
                financials:false,
                permanent:false,
                investment:false,
                deeds:false
            },
        }
        
            
    },
   
    
}
</script>
<style>
.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
    color: black;
    background-color: #FFF;
    border-right-color: #DCDFE6;
    border-left-color: #DCDFE6;
}
.el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover {
    color: black;
}
.el-upload-dragger .el-upload__text em {
    color: #3366ff;
    font-style: normal;
}
.el-upload {
    display: inline-block;
    text-align: center;
    cursor: pointer;
    outline: 0;
    width:100%;
}
.el-upload-dragger {
    background-color: #fff;
    border: 1px dashed #3366ff;
    border-radius: 6px;
    box-sizing: border-box;
    width: 100%;
    height: 180px;
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
</style>